import type React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ResizableTextarea from "../../../components/common/ResizableTextArea";
import { tokens } from "../../../theme";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface AdditionalNotesSectionProps {
  value: string;
  onChange: (value: string) => void;
}

const AdditionalNotesSection: React.FC<AdditionalNotesSectionProps> = ({
  value,
  onChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const reduxTheme = useSelector((state: RootState) => state.theme);

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Additional Notes
      </Typography>

      <ResizableTextarea
        label="Additional"
        value={value}
        onChange={onChange}
        colors={colors}
        reduxTheme={reduxTheme}
        placeholder="Any additional notes or special instructions..."
      />
    </Box>
  );
};

export default AdditionalNotesSection;
